// Display helpers shared across pages.

export function fmtMoney(n) {
  const v = Number(n) || 0
  return v.toLocaleString('en-US', {
    style: 'currency', currency: 'USD',
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  })
}

export function fmtDate(s) {
  if (!s) return '—'
  // Accept either a YYYY-MM-DD string or a millis timestamp.
  const d = typeof s === 'number' ? new Date(s) : new Date(`${s}T00:00:00`)
  if (Number.isNaN(d.getTime())) return s
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function fmtDateTime(ts) {
  if (!ts) return '—'
  return new Date(ts).toLocaleString('en-US', {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  })
}

export function statusPillClass(status) {
  if (status === 'paid' || status === 'active') return 'pill-green'
  if (status === 'pending' || status === 'sent') return 'pill-gold'
  if (status === 'overdue' || status === 'failed') return 'pill-red'
  if (status === 'suspended' || status === 'cancelled') return 'pill-gray'
  return 'pill-gray'
}
